export const ACCOUNT_URL = `user-access/account`;

export const ACCOUNT_REGISTER_URL = `${ACCOUNT_URL}/register`;

export const ACCOUNT_PRE_REGISTER_URL = `${ACCOUNT_URL}/pre-register`;

export const ACCOUNT_ACTIVATE_URL = `${ACCOUNT_URL}/activate`;

const ACCOUNT_RESET_PASSWORD_URL = `${ACCOUNT_URL}/reset-password`;

export const ACCOUNT_CHANGE_PASSWORD_URL = `${ACCOUNT_URL}/change-password`;

export const ACCOUNT_RESET_PASSWORD_INIT_URL = `${ACCOUNT_RESET_PASSWORD_URL}/init`;

export const ACCOUNT_RESET_PASSWORD_INIT_ADMIN_URL = `${ACCOUNT_RESET_PASSWORD_URL}/init/admin`;

export const ACCOUNT_RESET_PASSWORD_FINISH_URL = `${ACCOUNT_RESET_PASSWORD_URL}/finish`;

export const ACCOUNT_ADDRESSES_URL = `${ACCOUNT_URL}/addresses`;

export const ACCOUNT_PAYMENT_METHODS_URL = `${ACCOUNT_URL}/payment-methods`;

export const ACCOUNT_DELETE_URL = `${ACCOUNT_URL}/delete`;
